module.exports = __webpack_public_path__ + "img/Bent Link.bd66793a.png";